export const toTitleCase = (text) => {
    return text.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (match) => {
        return match.toUpperCase();
    });
};

export const underscoredToTitleCase = (underscoredString) => {
    if (!underscoredString) {
        return '';
    }

    const splitString = underscoredString.split('_');
    return splitString.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}

export const escapeUrl = (url) => new RegExp(`^${url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`);

export const copyToClipboard = (text) => {
    return navigator.clipboard.writeText(text);
};